"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sidebar = exports.SidebarComponent = exports.useSidebarContext = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const I18n_1 = require("@reactionable/core/lib/i18n/I18n");
const Sidebar_1 = require("@reactionable/core/lib/ui/layout/sidebar/Sidebar");
const react_1 = require("react");
const react_bootstrap_1 = require("react-bootstrap");
const Button_1 = tslib_1.__importDefault(require("react-bootstrap/Button"));
const Col_1 = tslib_1.__importDefault(require("react-bootstrap/Col"));
const Collapse_1 = tslib_1.__importDefault(require("react-bootstrap/Collapse"));
const Container_1 = tslib_1.__importDefault(require("react-bootstrap/Container"));
const Row_1 = tslib_1.__importDefault(require("react-bootstrap/Row"));
const NavItem_1 = require("../../nav/NavItem");
function useSidebarContext() {
    return Sidebar_1.useSidebarContext();
}
exports.useSidebarContext = useSidebarContext;
const SidebarItems = ({ children }) => {
    const { t } = I18n_1.useTranslation();
    const [open, setOpen] = react_1.useState(true);
    const { navItems } = useSidebarContext();
    return (jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: [jsx_runtime_1.jsx(Collapse_1.default, Object.assign({ in: open }, { children: jsx_runtime_1.jsxs(Col_1.default, Object.assign({ xs: "auto", className: "sidebar-left-side", style: {
                        borderRight: "solid 1px",
                        height: "93vh",
                        paddingTop: "1vh",
                        paddingLeft: 0,
                        paddingRight: 0,
                    } }, { children: [!open && (jsx_runtime_1.jsx(Button_1.default, Object.assign({ onClick: () => setOpen(!open), "aria-controls": t("Collapse sidebar"), "aria-expanded": open }, { children: t("Collapse sidebar") }), void 0)),
                        jsx_runtime_1.jsx(react_bootstrap_1.Nav, Object.assign({ className: "flex-column" }, { children: jsx_runtime_1.jsx(NavItem_1.NavItems, { navItems: navItems }, void 0) }), void 0)] }), void 0) }), void 0),
            jsx_runtime_1.jsx(Col_1.default, Object.assign({ className: "sidebar-right-side", style: { height: "89vh", overflow: "auto" } }, { children: children }), void 0)] }, void 0));
};
function SidebarComponent({ children }) {
    return (jsx_runtime_1.jsx(Container_1.default, Object.assign({ fluid: true, className: "sidebar-container", style: {
            paddingLeft: 0,
            paddingRight: 0,
        } }, { children: jsx_runtime_1.jsx(Row_1.default, { children: jsx_runtime_1.jsx(SidebarItems, { children: children }, void 0) }, void 0) }), void 0));
}
exports.SidebarComponent = SidebarComponent;
function Sidebar(props) {
    return jsx_runtime_1.jsx(Sidebar_1.Sidebar, Object.assign({ Component: SidebarComponent }, props), void 0);
}
exports.Sidebar = Sidebar;
//# sourceMappingURL=Sidebar.js.map